import { connect } from 'react-redux';
import { getFormFieldErrorsFromResponseJSON } from 'app/react/helpers/_index';
import { mapAccountContextToProps, mapEventContextToProps } from 'app/react/components/util/connectBeatswitchContext';
import * as actions from 'app/react/state/actions/_index';
import Modal from './ItemModalContainer';
import * as State from './ItemModalState';
import * as BookingItem from 'app/react/entities/events/bookings/items/index';

const FAILED_POPUP = 'Failed to update item.';
const SUCCESSFUL_POPUP = 'Item successfully updated.';

const mapStateToProps = (state) => {
    const {
        isOpened,
        isSaving,
        values = {},
        errors = {},
        itemId
    } = State.getUpdateModalState(state);

    return {
        ...mapAccountContextToProps(state),
        ...mapEventContextToProps(state),
        isCreating: false,
        isOpened,
        values,
        errors,
        isSaving,
        itemId,

        token: state.tokens.jwt
    };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    onSave: () => {
        const { itemId, values } = stateProps;
        dispatchProps.onSave(itemId, values);
    }
});

const mapDispatchToProps = (dispatch) => ({
    onClosed: () => {
        dispatch((State.setUpdateModalStateValue('isOpened', false)));
    },
    onChangeValue: (key, value) => {
        dispatch(State.setUpdateModalStateValue(`values.${key}`, value));
    },
    onSave: (itemId, values) => {
        dispatch((State.setUpdateModalStateValue('isSaving', true)));
        //const apiValues = Item.schemas.toAPI(values);
        dispatch(BookingItem.thunks.updateOneForCurrentContext(itemId, values))
            .then(({ error }) => {
                if (typeof error !== 'undefined') {
                    const errors = getFormFieldErrorsFromResponseJSON(error);
                    dispatch(actions.showErrorPopup(FAILED_POPUP));
                    dispatch(State.mergeUpdateModalState({
                        errors: errors,
                        isSaving: false
                    }));
                } else {
                    dispatch(actions.showSuccessPopup(SUCCESSFUL_POPUP));
                    dispatch(State.mergeUpdateModalState({
                        errors: {},
                        values: {},
                        isOpened: false,
                        isSaving: false
                    }));
                }
            });
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(Modal);
